import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { businessTypes } from 'app-components/flux/business';
import { useMultiFields } from 'app-components/flux/categories/categoryFormHooks';

import useStyles from './styles';
import { initialCaps } from './utils';

const TaxGroup = ({ type }: { type: string }) => {
  const { value, onValueChange } = useMultiFields('businessTaxInfo', type);

  return (
    <Checkbox
      checked={value.enabled}
      onChange={(e) => onValueChange({ name: 'enabled', value: e.target.checked })}
      color='primary'
    />
  );
};

const TaxInfoQBPSelectTaxGroups = () => {
  const { classes } = useStyles();

  return (
    <Stack mt={2} mb={1} direction='column' flex='1'>
      {Object.entries(businessTypes.taxGroupNames).map(([key, value]) => (
        <FormControlLabel
          className={classes.checkboxList}
          key={key}
          label={
            <Typography variant='bodyRegular'>
              {initialCaps(key)} (i.e. {value})
            </Typography>
          }
          control={<TaxGroup type={key}></TaxGroup>}
        />
      ))}
    </Stack>
  );
};

export default TaxInfoQBPSelectTaxGroups;
